export const Regex: Readonly<Record<string, RegExp>> = {
  textBetweenSquareBrackets: /\[(.*?)\]/,
  textBetweenParenthesis: /'(.*?)'/,
}

export const getRegexMatch = (regex: RegExp, str: string): string => {
  const matchDetails = regex.exec(str)

  if (matchDetails?.length) {
    return matchDetails[1]
  }

  return ''
}
